import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

const usePageTracking = () => {
  const location = useLocation();
  window?.ReactNativeWebView?.postMessage(window.location.href);

  useEffect(() => {
    const trackers = [
      {
        trackingId: "G-Q28LGJQ238",
      },
      {
        trackingId: "UA-90752062-1",
        gaOptions: { name: "ga3" },
      },
    ];
    ReactGA.initialize(trackers);
    ReactGA.pageview(location.pathname + location.search);
    ReactGA.pageview(location.pathname + location.search, ["ga3"]);
  }, [location]);
};

export default usePageTracking;
